<script>
export default {
  name: 'SidebarTopIcon',
  props: {
    size: {
      type: [Number, String],
      default: 20,
    },
    colorPrimary: {
      type: String,
      default: 'var(--primary)',
    },
    colorSecondary: {
      type: String,
      default: '#8E8E8E',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.4583 3.4415C17.2167 3.0915 16.9083 2.78317 16.5583 2.5415C15.7667 1.9665 14.7333 1.6665 13.4917 1.6665H6.50832C3.64165 1.6665 1.86665 3.28317 1.69165 6.0165H18.3167C18.25 4.9915 17.9583 4.12484 17.4583 3.4415Z"
      :fill="colorPrimary"
    />
    <path
      d="M1.66663 13.4916C1.66663 14.7333 1.96663 15.7666 2.54163 16.5583C2.78329 16.9083 3.09163 17.2166 3.44163 17.4583C4.23329 18.0333 5.26663 18.3333 6.50829 18.3333H13.4916C16.525 18.3333 18.3333 16.5249 18.3333 13.4916V7.2666H1.66663V13.4916ZM7.42496 12.0333L9.55829 9.89994C9.79996 9.65827 10.2 9.65827 10.4416 9.89994L12.575 12.0333C12.7 12.1583 12.7583 12.3166 12.7583 12.4749C12.7583 12.6333 12.7 12.7916 12.575 12.9166C12.3333 13.1583 11.9333 13.1583 11.6916 12.9166L9.99996 11.2333L8.30829 12.9166C8.06663 13.1583 7.66663 13.1583 7.42496 12.9166C7.18329 12.6749 7.18329 12.2833 7.42496 12.0333Z"
      :fill="colorSecondary"
    />
  </svg>
</template>
